import { Banner, Box, Button, Stack, Text } from '@customerio/pluma-components/react';
import { useState } from 'react';

interface AskUserQuestionErrorProps {
  error: string;
  onContinue?: () => void;
}

/**
 * Shown when `ask_user_question` args fail to parse.
 * Provides a Continue button so the conversation isn't permanently stuck.
 */
export function AskUserQuestionError({ error, onContinue }: AskUserQuestionErrorProps) {
  const [continued, setContinued] = useState(false);

  return (
    <Stack gap="100">
      <Banner
        variant="error"
        title="Failed to display question"
        description={
          <>
            <Text size="s">{error}</Text>
          </>
        }
      />
      {onContinue != null && !continued ? (
        <Box>
          <Button
            variant="subtle"
            size="sm"
            onClick={() => {
              setContinued(true);
              onContinue();
            }}
          >
            Continue
          </Button>
        </Box>
      ) : null}
    </Stack>
  );
}
